document.addEventListener('DOMContentLoaded', function () {
  // ===== CONFIG =====
  const maxFlavors = 3; // ✅ LIMIT TOTAL TO 3 CANS

  const flavorPrices = {
    "Beef": 40,
    "Chicken": 40,
    "Lamb": 40,
    "Turkey": 45,
    "Emu": 45
  };

  const CART_DRAWER_ID = 'site-cart-sidebar';
  const RELOAD_FLAG_KEY = 'openCartAfterReload';

  // Map flavor names to real Shopify variant IDs
  const variantIdByName = {
    "Beef": 46437635784923,
    "Chicken": 46437795266779,
    "Lamb": 46437796937947,
    "Turkey": 47933457596635,
    "Emu": 47176877506779
  };

  // ===== STATE =====
  let selectedFlavors = []; // [{ id, name, quantity }]
  let selectedPrice = 0;

  // ===== MAPS =====
  const flavorImageMap = {
    "Beef": "https://cdn.shopify.com/s/files/1/0601/9822/4091/files/beef_select.png?v=1756457251",
    "Chicken": "https://cdn.shopify.com/s/files/1/0601/9822/4091/files/chicken_select.png?v=1756457250",
    "Lamb": "https://cdn.shopify.com/s/files/1/0601/9822/4091/files/lamb_select.png?v=1756457250",
    "Turkey": "https://cdn.shopify.com/s/files/1/0601/9822/4091/files/turkey_1.png?v=1765477829",
    "Emu": "https://cdn.shopify.com/s/files/1/0601/9822/4091/files/emu_select.png?v=1756457250"
  };

  // ===== DOM =====
  const flavorButtons = document.querySelectorAll('.flavor-btn');
  const countDisplay = document.getElementById('selected-count');
  const maxDisplay = document.getElementById('max-cans');
  const pillsContainer = document.querySelector('.flavor-pills');
  const addBtn = document.getElementById('add-bundle-to-cart');
  const priceSummary = document.querySelector('.price-summary');

  // prevent form submits from sneaking in default product
  flavorButtons.forEach(b => !b.getAttribute('type') && b.setAttribute('type', 'button'));
  if (addBtn && !addBtn.getAttribute('type')) addBtn.setAttribute('type', 'button');

  // ===== HELPERS =====
  function getTotalSelectedQty() {
    return selectedFlavors.reduce((sum, f) => sum + (f.quantity || 0), 0);
  }

  function updatePriceUI() {
    if (!priceSummary) return;

    selectedPrice = selectedFlavors.reduce((total, flavor) => {
      return total + (flavorPrices[flavor.name] || 0) * (flavor.quantity || 0);
    }, 0);

    priceSummary.innerHTML = `
      <div class="price-line">
        <del></del>
        <strong id="bundle-price">$${selectedPrice}.00</strong>
      </div>
    `;
  }

  function legacyUUID() {
    let d = Date.now();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  }

  function openCartDrawer() {
    const drawer = document.getElementById(CART_DRAWER_ID);
    if (drawer) {
      drawer.classList.add('open', 'is-open', 'active');
      drawer.setAttribute('aria-hidden', 'false');
      drawer.style.display = 'block'; // fallback
    }
    document.dispatchEvent(new CustomEvent('cart:open', { detail: { source: 'bundle' } }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'bundle' } }));
    const opener =
      document.querySelector('[data-action="open-cart"]') ||
      document.querySelector(`[aria-controls="${CART_DRAWER_ID}"]`);
    if (opener) opener.click();
  }

  function handleOpenCartAfterReload() {
    if (sessionStorage.getItem(RELOAD_FLAG_KEY) === '1') {
      sessionStorage.removeItem(RELOAD_FLAG_KEY);
      setTimeout(() => {
        fetch('/cart.js', { cache: 'no-store' }).finally(() => {
          openCartDrawer();
        });
      }, 250);
    }
  }

  function updateUI() {
    if (maxDisplay) maxDisplay.textContent = String(maxFlavors);

    // ✅ count = total qty, not unique flavors
    if (countDisplay) countDisplay.textContent = String(getTotalSelectedQty());

    if (pillsContainer) {
      pillsContainer.innerHTML = '';

      selectedFlavors.forEach((flavor, index) => {
        const pill = document.createElement('div');
        pill.className = 'image-pill';
        pill.innerHTML = `
          <div class="flavor-icon" data-name="${flavor.name}">
            <img src="${flavorImageMap[flavor.name] || ''}" alt="${flavor.name}">
            ${flavor.quantity > 1 ? `<div class="quantity-badge">${flavor.quantity}</div>` : ''}
          </div>
          <button class="remove-flavor" type="button" aria-label="Remove ${flavor.name}" data-index="${index}">
            <svg width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.926701 5.56685L5.56709 0.926464L6.35455 1.71392L1.71416 6.35431L0.926701 5.56685ZM0.926701 1.71392L1.71416 0.926464L6.35455 5.56685L5.56709 6.35431L0.926701 1.71392Z" fill="white"></path>
            </svg>
          </button>
        `;
        pillsContainer.appendChild(pill);
        document.querySelectorAll(`[data-id="${flavor.id}"]`).forEach(btn => btn.classList.add('selected'));
      });

      // optional empty slots up to 3
      for (let i = getTotalSelectedQty(); i < maxFlavors; i++) {
        const empty = document.createElement('div');
        empty.className = 'image-pill empty';
        pillsContainer.appendChild(empty);
      }
    }

    if (addBtn) {
      // ✅ only allow add to cart when exactly 3 cans selected
      if (getTotalSelectedQty() === maxFlavors) {
        addBtn.disabled = false;
        addBtn.textContent = "Add to Cart";
      } else {
        addBtn.disabled = true;
        addBtn.textContent = `Please select ${maxFlavors} flavors`;
      }
    }
  }

  // ===== AJAX CART HELPER =====
  async function addItems(items) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
  }

  // ===== EVENTS =====
  flavorButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const id = button.dataset.id; // used only for UI highlighting
      const name = button.dataset.name;
      if (!name) return;

      // ✅ HARD LIMIT: total qty cannot exceed 3
      if (getTotalSelectedQty() >= maxFlavors) return;

      const existingFlavor = selectedFlavors.find(f => f.name === name);
      if (existingFlavor) {
        existingFlavor.quantity += 1;
      } else {
        selectedFlavors.push({ id, name, quantity: 1 });
      }

      updateUI();
      updatePriceUI();
    });
  });

  if (pillsContainer) {
    pillsContainer.addEventListener('click', (e) => {
      const removeBtn = e.target.closest('.remove-flavor');
      if (!removeBtn) return;

      const index = parseInt(removeBtn.dataset.index, 10);
      if (!Number.isInteger(index)) return;

      const flavor = selectedFlavors[index];
      if (!flavor) return;

      if (flavor.quantity > 1) {
        flavor.quantity -= 1;
      } else {
        selectedFlavors.splice(index, 1);
      }

      updateUI();
      updatePriceUI();
    });
  }

  // ===== ADD TO CART =====
  if (addBtn) {
    addBtn.removeAttribute('onclick');

    addBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      // ✅ must be exactly 3
      if (getTotalSelectedQty() !== maxFlavors) return;

      if (addBtn.dataset.busy === '1') return;
      addBtn.dataset.busy = '1';

      const originalText = addBtn.innerText;
      addBtn.disabled = true;
      addBtn.innerText = 'Adding...';

      try {
        const counts = selectedFlavors.reduce((acc, f) => {
          acc[f.name] = (acc[f.name] || 0) + f.quantity;
          return acc;
        }, {});

        const bundleId = (window.crypto && window.crypto.randomUUID)
          ? window.crypto.randomUUID()
          : legacyUUID();

        const items = Object.entries(counts).flatMap(([name, qty]) => {
          const vid = variantIdByName[name];
          if (!vid || qty <= 0) return [];
          return [{
            id: Number(vid),
            quantity: qty,
            properties: {
              "_bundle_id": bundleId,
              "Flavor": name
            }
          }];
        });

        if (!items.length) throw new Error('No valid flavor variants found to add.');

        await addItems(items);

        sessionStorage.setItem(RELOAD_FLAG_KEY, '1');
        window.location.reload();
      } catch (err) {
        console.error('[Add flavors] Error:', err);
        addBtn.disabled = false;
        addBtn.innerText = originalText;
      } finally {
        addBtn.dataset.busy = '0';
      }
    }, { capture: true });
  }

  // ===== INIT =====
  updateUI();
  updatePriceUI();
  handleOpenCartAfterReload();
});
